import React, { createContext, useContext, useState } from "react";
import AppointmentDialog from "../components/AppointmentDialog";

const BookingContext = createContext({ open: () => {} });

export const useBooking = () => useContext(BookingContext);

export const BookingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  return (
    <BookingContext.Provider value={{ open: () => setOpen(true), close: () => setOpen(false) }}>
      {children}
      <AppointmentDialog open={open} onOpenChange={setOpen} />
    </BookingContext.Provider>
  );
};
